var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaunchpadChangeUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 4.50712H0.4375C0.356251 4.50712 0.276607 4.48527 0.207493 4.44402C0.138378 4.40276 0.082524 4.34374 0.0461884 4.27355C0.00985275 4.20337 -0.00552861 4.1248 0.001768 4.04664C0.00906461 3.96849 0.0387508 3.89385 0.0875002 3.83107L2.8 0.338023C2.8815 0.23307 2.98719 0.147886 3.10869 0.0892152C3.23019 0.0305447 3.36416 0 3.5 0C3.63584 0 3.76981 0.0305447 3.89131 0.0892152C4.01281 0.147886 4.1185 0.23307 4.2 0.338023L6.9125 3.83107C6.96125 3.89385 6.99094 3.96849 6.99823 4.04664C7.00553 4.1248 6.99015 4.20337 6.95381 4.27355C6.91748 4.34374 6.86162 4.40276 6.79251 4.44402C6.72339 4.48527 6.64375 4.50712 6.5625 4.50712H4.375V10H2.625V4.50712Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchpadChangeUp);
export default __webpack_public_path__ + "static/media/launchpad-change-up.9ea936d4bc8df4651a7f4322e00023d6.svg";
export { ForwardRef as ReactComponent };